export default {
    sync_ctc_info_title: "Sync CTC Information",
    sync_ctc_info_description: "Are you sure you want to sync CTC information?",
    sync_ctc_info_label: "Sync",
    sync_ctc_info_success_message: "The CTC information has been synchronized",
    sync_ctc_info_error_message: "The CTC information has not been synchronized",
}